// Dependencies
import React, { useEffect, useState } from 'react';
import uuid from 'react-uuid';

// Components
import Container from '../../container/container';
import Modal from '../../modal/modal';
import Image from '../../image/image';

// Utilities
import slugify from '../../../utilities/slugify';

// Hooks
import usePressArticlePostType from '../../../hooks/usePressArticlePostType';

// Styles
import PressArticlesStyles from './pressArticles.styles';

export default function PressArticles() {
  const pressArticles = usePressArticlePostType();

  const [currentModal, setCurrentModal] = useState(null);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      const currentTeamMember = params?.article;
      setCurrentModal(currentTeamMember);
    }
  }, [setCurrentModal]);

  const handleOpenModal = (articleTitle) => {
    const articleId = slugify(articleTitle);

    setCurrentModal(articleId);

    if (typeof window !== 'undefined')
      window.history.replaceState({}, '', `?article=${articleId}`);
  };

  const handleCloseModal = () => {
    setCurrentModal(null);
  };

  return (
    <PressArticlesStyles>
      <Container>
        {pressArticles && (
          <ul className="articles">
            {pressArticles.map((article) => (
              <li className="article" key={article?.title}>
                {article?.press?.articles?.length > 0 &&
                  article?.press?.articles.length === 1 && (
                    <a
                      href={article?.press?.articles[0]?.link}
                      target="_blank"
                      rel="noreferrer"
                      className="link"
                      aria-label={article?.title}
                    >
                      <Image
                        image={article?.featuredImage?.node}
                        className="image"
                        filter={false}
                      />
                    </a>
                  )}

                {article?.press?.articles?.length > 0 &&
                  article?.press?.articles.length > 1 && (
                    <>
                      <button
                        onClick={() => handleOpenModal(article?.title)}
                        type="button"
                        aria-label={article?.title}
                      >
                        <Image
                          image={article?.featuredImage?.node}
                          className="image"
                          filter={false}
                          flex
                          alignItems="center"
                          justifyContent="center"
                        />
                      </button>
                      <Modal
                        modalId={slugify(article?.title)}
                        modalUrlKey="press-article"
                        currentModal={currentModal}
                        handleClose={handleCloseModal}
                        header={<h2>{article?.title} Articles</h2>}
                      >
                        {article?.press?.articles.map((innerArticle) => (
                          <div className="inner-article" key={uuid()}>
                            <h3 className="headline">
                              {innerArticle?.headline}:
                            </h3>
                            <a
                              href={innerArticle?.link}
                              target="_blank"
                              rel="noreferrer"
                              className="btn dark"
                            >
                              Read Article
                            </a>
                          </div>
                        ))}
                      </Modal>
                    </>
                  )}

                {!article?.press?.articles && (
                  <span className="no-link">
                    <Image
                      image={article?.featuredImage?.node}
                      className="image"
                      filter={false}
                    />
                  </span>
                )}
              </li>
            ))}
          </ul>
        )}
      </Container>
    </PressArticlesStyles>
  );
}
